<template>
  <v-card>
    <v-card-title class="text-subtitle-1">
      Tải về App HRM
    </v-card-title>
        <a href="https://play.google.com/store/apps/details?id=vn.trungsoncare.trung_son_hrm" class="mx-2">
            <img src="/static/icons/google_play_2.png" style="height: 47px; width: 150px;">
        </a>
      {{ getOS() }}
    <v-card-text>
    
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  methods: {
    getOS() {
      const ua = navigator.userAgent || navigator.vendor || window.opera

        if (/android/i.test(ua)) return 'android'
        if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios'
        if (/windows phone/i.test(ua)) return 'windows-phone'
        if (/windows/i.test(ua)) return 'windows'
        if (/mac os x/i.test(ua)) return 'mac'
        if (/linux/i.test(ua)) return 'linux'

      return 'unknown'
    }
  }
}
</script>